import { render, staticRenderFns } from "./ProgramDetails.vue?vue&type=template&id=8041d0ee&scoped=true"
import script from "./ProgramDetails.vue?vue&type=script&lang=js"
export * from "./ProgramDetails.vue?vue&type=script&lang=js"
import style0 from "./ProgramDetails.vue?vue&type=style&index=0&id=8041d0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8041d0ee",
  null
  
)

export default component.exports